module.exports = __webpack_public_path__ + "img/icon-dashboard.9ff62c70.svg";